<template>
    <div class="main">
        <!-- 搜索及筛选 -->
        <div class="whiteBg main-top">
            <el-row :gutter="20">
                <el-col :span="7">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">用户名：</div>
                        <el-input v-model="artName" placeholder="请输入用户名" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="7" :offset="1">
                    <div class="box box-align-center mt-input">
                        <div class="mti-txt">账号：</div>
                        <el-input v-model="account" placeholder="请输入账号" clearable></el-input>
                    </div>
                </el-col>
                <el-col :span="8" :offset="1">
                    <div class="box box-align-center box-pack-end mt-btns">
                        <el-button type="primary" icon="el-icon-search" @click="getList()">搜索</el-button>
                        <el-button plain icon="el-icon-refresh" @click="resetList">重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 新增 -->
        <div class="whiteBg main-middle">
            <div class="box box-align-center mt-btns">
                <el-button type="primary" plain icon="el-icon-plus" @click="buildNewTopic">新增用户</el-button>
                <el-button type="warning" plain icon="el-icon-download" @click="exportData">导出</el-button>
            </div>
            <dy-table :columns="columns" style="margin-top: 12px;" :table-data="tableData" v-loading="tableLoading"
                :total="total" :page-num="currentPage" :page-size="pageSize" @current-change="onCurrentChange"
                element-loading-text="加载中"></dy-table>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="addVisible" width="70%" :close-on-click-modal="false">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px">
                <el-divider content-position="left">基础信息</el-divider>
                <el-row class="mt12">
                    <el-col :span="10">
                        <el-form-item label="账号：" prop="userAccount">
                            <el-input v-model="ruleForm.userAccount" placeholder="请输入账号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="用户名：" prop="userName">
                            <el-input v-model="ruleForm.userName" placeholder="请输入用户名"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="mt12" v-show="dialogTitle == '新建用户'">
                    <el-col :span="10">
                        <el-form-item label="密码：" prop="password">
                            <el-input v-model="ruleForm.password" placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="重复密码：" prop="repassword">
                            <el-input v-model="ruleForm.repassword" placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="mt12">
                    <el-col :span="10">
                        <el-form-item label="手机号：" prop="userTel">
                            <el-input v-model="ruleForm.userTel" placeholder="请输入账号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="邮箱：" prop="email">
                            <el-input v-model="ruleForm.email" placeholder="请输入邮箱"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="mt12">
                    <el-col :span="10">
                        <el-form-item label="性别：" prop="username">
                            <el-radio-group v-model="ruleForm.gender">
                                <el-radio :label="1">男</el-radio>
                                <el-radio :label="2">女</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="选择用户组：" prop="groupId">
                            <el-select v-model="ruleForm.groupId" placeholder="请选择用户组" multiple>
                                <el-option v-for="item in groupList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <template v-if="false">
                    <el-divider content-position="left" class="mt24">员工信息</el-divider>
                    <el-row class="mt12">
                        <el-col :span="12" :offset="2">
                            <el-form-item label="所属学校/组织：" prop="organizationId">
                                <el-select v-model="ruleForm.organizationId" placeholder="请选择">
                                    <el-option v-for="item in schoolList" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="mt12">
                        <el-col :span="12" :offset="2">
                            <el-form-item label="工号：" prop="userNumber">
                                <el-input v-model="ruleForm.userNumber" placeholder="请输入工号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </template>
                <div class="box box-align-center box-pack-end mt-btns mt24" style="margin-right: 30px;">
                    <el-button type="primary" plain @click="submitForm('ruleForm')">保存</el-button>
                    <el-button type="danger" plain @click="() => addVisible = false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="权限分配" :visible.sync="rightVisible" width="60%" :close-on-click-modal="false">
            <el-tree :data="treeData" ref="treeRef" node-key="id" accordion show-checkbox @check="handleCheckChange">
            </el-tree>
            <div class="box box-align-center box-pack-end mt-btns mt24" style="margin-right: 30px;">
                <el-button type="primary" plain @click="trueSetRight">保存</el-button>
                <el-button type="danger" plain @click="() => rightVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'

import host from '@/api/index';
import { formatJson } from '@/utils/utils';
import { queryUser, updateUser, addUser, queryGroup, queryUserAuth } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { arrToStr } from '@/utils/utils';

var that = null;
export default {
    components: {
        DyTable,
    },
    data() {
        const { doEdit } = this;
        const { doReset } = this;
        const { doRight } = this;
        const { doDelete } = this;
        const { changeUserStatus } = this;
        return {
            artName: '',
            tableLoading: true,
            dialogTitle: '新建用户',
            columns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'userAccount',
                    title: '账号'
                },
                {
                    key: 'userName',
                    title: '用户名'
                },
                {
                    key: 'userTel',
                    title: '手机号'
                },
                {
                    key: 'groupName',
                    title: '所属用户组'
                },
                {
                    key: 'userStatus',
                    title: '状态',
                    render: ({ row }) => {
                        return (
                            <div>
                                <el-switch
                                    value={row.userStatus == 1 ? true : false}
                                    onChange={() => changeUserStatus(row)}
                                />
                            </div>
                        );
                    }
                },
                {
                    key: '',
                    title: '操作',
                    width: 250,
                    render: ({ row }) => {
                        return (
                            <div class="box box-align-center box-pack-center">
                                <el-link type="primary" onClick={() => doEdit(row)}>编辑</el-link>
                                <el-link type="primary" class="ml12" onClick={() => doReset(row)}>重置密码</el-link>
                                <el-link type="primary" class="ml12" onClick={() => doRight(row)}>权限分配</el-link>
                                <el-link type="danger" class="ml12" onClick={() => doDelete(row)}>删除</el-link>
                            </div>
                        );
                    }
                },
            ],
            tableData: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            ruleForm: {//新建表单数据
                email: '',
                gender: 1,
                groupId: '',//用户组id列表
                organizationId: '',
                password: '',
                repassword: '',
                userAccount: '',
                userName: '',
                userTel: '',
                userNumber: ''
            },
            rules: {
                userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                userAccount: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                groupId: [{ required: true, message: '请选择用户组', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                repassword: [{ required: true, message: '请确认密码', trigger: 'blur' }],
            },
            addVisible: false,
            status: null,
            UserName: '',
            currentUser: null,
            rightVisible: false,//权限分配
            treeData: [],
            menusList: [],//分配权限列表数据
            account: '',
            groupList: [],
            schoolList: [{
                label: '华夏学校',
                value: ''
            }],
            tHeader: ['账号', '用户名', '手机号', '所属用户组', '状态'],
            tValue: ['userAccount', 'userName', 'userTel', 'groupName', 'userStatus'],
        }
    },
    mounted() {
        that = this;
        that.getList();
    },
    computed: {
        uploadImg() {
            return host.uploadImgUrl;
        },
        headers() {
            return {
                'bg-token': localStorage.getItem('token') // 直接从本地获取token就行
            };
        }
    },
    methods: {
        //重置密码
        doReset(obj) {
            console.log(obj, '重置密码');
            that.$confirm('确认要重置密码吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let info = {
                    userName: obj.userName,
                    userId: obj.userId,
                    userStatus: obj.userStatus,
                    password: '111111',
                    isDelete: 0,
                    menus: [],
                    needAuthority: false
                };
                console.log(info);
                var data = encrypt(JSON.stringify(info));
                updateUser(data).then((res) => {
                    this.$message({
                        showClose: true,
                        message: '重置成功',
                        type: 'success'
                    });
                    that.rightVisible = false;
                    that.getList();
                });
            })
        },
        // 确定分配权限
        trueSetRight() {
            let info = {
                userName: that.currentUser.userName,
                userId: that.currentUser.userId,
                userStatus: that.currentUser.userStatus,
                isDelete: 0,
                menus: that.menusList,
                needAuthority: true
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            updateUser(data).then((res) => {
                this.$message({
                    showClose: true,
                    message: '分配成功',
                    type: 'success'
                });
                that.rightVisible = false;
                that.getList();
            });
        },
        // 获取权限数据
        handleCheckChange(checkedNodes, checkedKeys) {
            console.log(checkedNodes, checkedKeys);
            that.menusList = checkedKeys.checkedKeys;
        },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].subs != '' && arr[i].subs != null && arr[i].subs != undefined) {
                        children.push({
                            id: arr[i].id,
                            label: arr[i].name,
                            disabled:arr[i].disabled,
                            children: this.listFor(arr[i].children),
                        });
                    } else {
                        if (arr[i].id != 0) {
                            children.push({
                                id: arr[i].id,
                                label: arr[i].name,
                                disabled:arr[i].disabled,
                                children: this.listFor(arr[i].children),
                            });
                        }
                    }
                }
            } else {
                return;
            }
            return children;
        },
        //权限分配
        doRight(obj) {
            console.log('权限分配', obj);
            that.currentUser = obj;
            // let arr = JSON.parse(localStorage.getItem('menuList'));
            // that.treeData = that.listFor(arr);
            // console.log('treeData', that.treeData);
            let info = {
                userId: obj.userId
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            queryUserAuth(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('权限', ress);
                    that.treeData = that.listFor(ress.menuVOS);
                    that.rightVisible = true;
                    that.$nextTick(() => {
                        that.$refs.treeRef.setCheckedKeys(ress.menuList);
                    });
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        // 切换按钮
        changeUserStatus(obj) {
            console.log(obj);
            let info = {
                userName: obj.userName,
                userId: obj.userId,
                userStatus: obj.userStatus == 1 ? 0 : 1,
                isDelete: 0,
                menus: '',
                needAuthority: false
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            updateUser(data).then((res) => {
                this.$message({
                    showClose: true,
                    message: '修改成功',
                    type: 'success'
                });
                that.getList();
            });
        },
        //新建
        buildNewTopic() {
            that.dialogTitle = '新建用户';
            that.ruleForm = {
                email: '',
                gender: 1,
                groupId: '',//用户组id列表
                organizationId: '',
                password: '',
                repassword: '',
                userAccount: '',
                userName: '',
                userTel: '',
                userNumber: ''
            }
            that.rules = {
                userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                userAccount: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                groupId: [{ required: true, message: '请选择用户组', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                repassword: [{ required: true, message: '请输入重复密码', trigger: 'blur' }],
            };
            if (that.groupList.length == 0) {
                that.getGroupList();
            }
            that.addVisible = true;
        },
        //重置列表
        resetList() {
            that.currentPage = 1;
            that.artName = '';
            that.account = '';
            that.getList();
        },
        //编辑
        doEdit(obj) {
            that.dialogTitle = '编辑用户';
            console.log(obj, '编辑');
            that.ruleForm = obj;
            let arr = obj.groupId.split('/');
            that.ruleForm.groupId = arr.map(item => item - 0)
            that.rules = {
                userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                userAccount: [{ required: true, message: '请输入账号', trigger: 'blur' }],
                groupId: [{ required: true, message: '请选择用户组', trigger: 'blur' }],
            };
            if (that.groupList.length == 0) {
                that.getGroupList();
            }
            that.addVisible = true;
        },
        //删除
        doDelete(obj) {
            that.$confirm('确认要删除此用户吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let info = {
                    userName: obj.userName,
                    userId: obj.userId,
                    userStatus: 0,
                    isDelete: 1,
                    menus: '',
                    needAuthority: false
                };
                console.log(info);
                var data = encrypt(JSON.stringify(info));
                updateUser(data).then((res) => {
                    this.$message({
                        showClose: true,
                        message: '删除成功',
                        type: 'success'
                    });
                    that.getList();
                });
            })
        },
        // 提交表单
        submitForm(formName) {
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    if (that.ruleForm.password != that.ruleForm.repassword) {
                        return that.$message({
                            showClose: true,
                            message: '两次密码不一致',
                            type: 'error'
                        });
                    }
                    var info = that.ruleForm;
                    info.groupIdsStr = arrToStr(that.ruleForm.groupId);
                    console.log(info, '我是表单');
                    var data = encrypt(JSON.stringify(info));
                    if (that.dialogTitle == '编辑用户') {
                        updateUser(data).then((res) => {
                            if (res.result == 1) {
                                console.log(res);
                                that.addVisible = false;
                                that.getList();
                                that.$message({
                                    showClose: true,
                                    message: '保存成功',
                                    type: 'success'
                                });
                            } else {
                                that.$message({
                                    showClose: true,
                                    message: res.msg,
                                    type: 'error'
                                });
                            }
                        });
                        return;
                    }
                    // 新增用户
                    addUser(data).then((res) => {
                        if (res.result == 1) {
                            console.log(res);
                            that.addVisible = false;
                            that.getList();
                            that.$message({
                                showClose: true,
                                message: '新增成功',
                                type: 'success'
                            });
                        } else {
                            that.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error'
                            });
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        onCurrentChange(val) {
            that.currentPage = val
            that.getList()
        },
        //导出数据
        exportData() {
            var query = {
                userName: '',
                userAccount: '',
                userId: '',
                needPage: false
            };
            const queryData = encrypt(JSON.stringify(query))
            queryUser(queryData).then(resp => {
                var data = JSON.parse(decrypt(resp.data.replace(/[\r\n]/g, '')));
                that.levelList = data.map(item=>{
                    return {
                        ...item,
                        userStatus:item.userStatus == 1 ? '启用' : '禁用'
                    }
                });
                import('@/components/ExportExcel/Export2Excel').then(excel => {
                    const data = formatJson(that.tValue, that.levelList);
                    excel.export_json_to_excel({
                        header: that.tHeader,
                        data,
                        filename: '用户列表',
                        autoWidth: true,
                        bookType: 'xlsx'
                    });
                });
            }, () => {
                this.isloading = false
            })

        },
        //获取用户列表
        getList() {
            that.tableLoading = true;
            let info = {
                userName: that.artName,
                userAccount: that.account,
                userId: '',
                page: that.currentPage,
                pageSize: that.pageSize,
                needPage: true
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            queryUser(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('列表', ress);
                    that.total = ress.total;
                    that.currentPage = ress.pageNum;
                    that.tableData = ress.list;
                    that.tableLoading = false;
                    that.chapterTableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取用户组列表
        getGroupList() {
            let info = {
                groupName: '',
                needPage: false
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            queryGroup(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('用户组列表', ress);
                    let arr = ress.filter(item => item.groupStatus == 1);
                    that.groupList = arr.map(item => {
                        return {
                            label: item.groupName,
                            value: item.groupId
                        }
                    });
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
    min-width: 100px;
    text-align: center;
    padding: 0;
}

/deep/.el-dropdown {
    margin-right: 10px;
}

/deep/.el-form-item__label {
    text-align: right;
    margin-left: 0px !important;
}

/deep/.el-form-item--small .el-form-item__content,
.el-form-item--small .el-form-item__label {
    margin-left: 0 !important;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }
.main {
    padding-top: 0 !important;
    padding-right: 0 !important;
}

.main-top {
    padding: 20px 15px;
    border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

    .mti-txt {
        white-space: nowrap;
    }
}

.main-middle {
    padding: 15px 11px;
}

.common-btns {
    padding: 0 22px 33px;
}
</style>